"use strict";

(function (global) {
  var BUTTONS = {
    RUN_AGENT: "run_and_resume_button",
    WITHOUT_AGENT: "work_without_agent_button",
    CANCEL: "modal_cancel_button_"
  };

  // Интервал пинга агента.
  var PING_INTERVAL = 1000;
  // Время для предупреждения о долгом запуске агента.
  var PING_SUSPECT_FAIL_TIME = 10000;
  // Время, после которого перестаем пинговать.
  var PING_MAX_TIME = 30000;

  var RunWithAgentDialog = WA.CMP.dialogs.BaseDialog.extend({
    className: 'RunWithAgentDialog',
    title: L("AGENT_APP_NAME"),
    mainText: L("AGENT_RUN_DIALOG_MAIN_TEXT"),
    additionalText: L("AGENT_RUN_DIALOG_INSTALL_TEXT"),
    agentAction: null,
    _agentStartTimeoutID: null,
    _agentStartFailTimeoutID: null,
    _waitDialog: null,

    /**
    * Инициализация диалога.
    *
    * @method WebAccess.components.dialogs.RunWithAgentDialog#init
    * @param {object} settings Настройки диалога
    */
    init: function (settings) {
      var me = this;
      me._super($.extend({}, settings, { isShowCancelButton: true, isShowOkButton: false }));

      me.bind(me['class'].EVENT.AFTER_CLOSE, function () {
        Core.agent.cancelStart();
        me._clearCheckAgentTimers();
      });
    },

    /**
    * Показать диалог.
    *
    * @method WebAccess.components.dialogs.RunWithAgentDialog#show
    * @return WebAccess.components.dialogs.RunWithAgentDialog
    */
    show: function () {
      var me = this;
      me._initButtons();
      me.setHtml(me._getHtml());

      me._super();
      me._initDownloadLink();
      me._initUpdateHandling();

      // Навешиваем событие на иконку "?".
      BindHelpIcoClickOnModalWindow('RunWithAgentDialog', me._jDialog.parents('.ui-dialog'));

      return me;
    },

    /**
    * Запустить агент.
    *
    * @private
    */
    _runAgent: function () {
      var me = this;
      me.enableButtonWaitState(BUTTONS.RUN_AGENT, L("AGENT_STARTING"));
      me._initCheckAgentTimers();

      // Запустить агент и выполнить действие.
      Core.agent.start(PING_MAX_TIME).done(function () {
        log.info('AGENT', 'Agent is started from dialog.')
        if (me.agentAction)
          me.agentAction();
        me.close();
      }).fail(function (err) {
        me.inlineHint.showError(err.message);
      }).always(function () {
        me._clearCheckAgentTimers();
      });
    },

    /**
    * Работать без агента.
    *
    * @private
    */
    _disableAgent: function () {
      Core.agent.disable();
    },

    /**
    * Инициализировать timeout функции для отображения информации в диалоге.
    *
    * @private
    */
    _initCheckAgentTimers: function () {
      var me = this;
      // Предупреждение
      me._agentStartTimeoutID = setTimeout(function() {
          me.inlineHint.showWarning(L("AGENT_START_IS_TOO_LONG"));
        },
        PING_SUSPECT_FAIL_TIME);

      // Прекратить
      me._agentStartFailTimeoutID = setTimeout(function() {
          Core.agent.cancelStart();
          me.inlineHint.showError(L("AGENT_LAUNCHING_WAS_FAILED"));
          me._initButtons();
          me.updateButtons();
        },
        PING_MAX_TIME);
    },

    /**
    * Очистить timeout функции для отображения информации в диалоге.
    *
    * @private
    */
    _clearCheckAgentTimers: function () {
      var me = this;
      clearTimeout(me._agentStartTimeoutID)
      clearTimeout(me._agentStartFailTimeoutID);
      log.info('AGENT', 'Agent dialog info timers destroyed');
    },

    /**
    * Инициализировать кнопки для диалога.
    *
    * @private
    */
    _initButtons: function () {
      var me = this;
      me.modalWindowButtons = [];
      me.modalWindowButtons.push({
        id: BUTTONS.RUN_AGENT,
        text: L("RUN_AND_RESUME"),
        click: function () {
          me._runAgent();
          return false;
        },
        'class': 'primary'
      });
      me.modalWindowButtons.push({
        id: BUTTONS.WITHOUT_AGENT,
        text: L("CONTINUE_WITHOUT_AGENT"),
        click: function () {
          me._disableAgent();
        }
      });
      if (!_.findWhere(me.modalWindowButtons, { id: BUTTONS.CANCEL + me.id })) {
        me.modalWindowButtons.push({
          id: BUTTONS.CANCEL + me.id,
          text: me.cancelText,
          click: function () { me.close(); return false; },
          'data-name': 'CancelButton'
        });
      }
    },

    /**
    * Инициализировать ссылку на скачивание агента.
    *
    * @private
    */
    _initDownloadLink: function () {
      var me = this;
      me._jDialog.find('.agent-dialog_download-link').click(function (event) {
        log.info('AGENT', 'Agent downloading...');
        Core.agent.download(this).done(function (platform) {
          me.fire(me['class'].EVENT.AFTER_DOWNLOAD, platform);
        }).fail(function () {
          me.fire(me['class'].EVENT.AFTER_DOWNLOAD, null);
        });

        event.preventDefault();
        return false;
      });
    },

    /**
    * Возвращает html-разметку для окна.
    * @private
    */
    _getHtml: function () {
      var mainTextHtml = '<div class="upper-area">' + this.mainText + '</div>';
      var additionalTextHtml = '<div class="lower-area">' + this.additionalText + '</div>';
      var html = '<div class="main-area">' + mainTextHtml + additionalTextHtml + '</div>';
      return html;
    },

    // Обработка событий обновления агента.
    _initUpdateHandling: function () {
      var me = this;
      Core.agent.beforeUpdating(function () { me._beforeUpdating(); });
      Core.agent.onUpdating(function (progress) { me._onUpdating(progress); });
      Core.agent.afterUpdating(function () { me._afterUpdating(); });
      Core.agent.onFailUpdating(function () { me._onFailUpdating(); });

      log.info('AGENT', 'Agent updating handlers was initalized');
    },

    // До начала процесса обновления.
    _beforeUpdating: function () {
      var me = this;
      log.info('AGENT', 'Agent before updating was triggered');

      me._waitDialog = waitDialog();
      me._waitDialog.show();
      // Если обновляемся, то не надо ожидать запуска агента
      me._clearCheckAgentTimers();

      function waitDialog() {
        var spinnerImage = 'spinner.gif';
        var dialog = new WA.CMP.dialogs.BaseDialog();
        dialog.removeDefaultButtons();
        dialog.removeCloseButton();
        dialog.title = L('AGENT_APP_NAME');
        dialog.setHtml(format('<img src="/images/' + spinnerImage + '" style="vertical-align: -10%; margin-right: 10px" /><span id="spinnerText">{0}</span>', L('AGENT_IS_BEING_UPDATED')));

        return dialog;
      };
    },
    // В процессе обновления.
    _onUpdating: function (progress) {
      log.info("AGENT", "Agent updating status: " + progress);
    },
    // После обновления.
    _afterUpdating: function () {
      var me = this;
      if (me._waitDialog)
        me._waitDialog.close();
      // Снова инициализируем таймеры
      me._initCheckAgentTimers();
      // Отключить обработчики, они больше не нужны
      me._unbindUpdateHandlers();
    },
    // Если обновление завершилось с ошибкой.
    _onFailUpdating: function () {
      var me = this;
      if (me._waitDialog)
        me._waitDialog.close();
      me.inlineHint.showError(L("AGENT_UPDATING_WAS_FAILED"));
      me.disableButtonWaitState(BUTTONS.RUN_AGENT);
      me._clearCheckAgentTimers();
    },
    // Отключить обработчики событий обновления агента.
    _unbindUpdateHandlers: function () {
      var me = this;
      Core.agent.unbind(Core.agent.EVENT.BEFORE_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.ON_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.AFTER_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.ON_FAIL_UPDATING);
    }

  }, {
    EVENT: $.extend({
      // Событие срабатывает после старта агента.
      AFTER_START: 'start',

      // Событие срабатывает после скачивания агента.
      AFTER_DOWNLOAD: 'download'
    }, WA.CMP.dialogs.BaseDialog.EVENT)
  });

  global.RunWithAgentDialog = RunWithAgentDialog;
})(window.Core.agent);